/**
 * RTWO Blockchain Core Foundation — Runtime Factory
 * RTWO v2.2 | Module ID: RTWO-BLCK-001
 */

import { getProtocolRepositoriesSingleton } from '../../blockchain-protocol-engine/repositories/protocol-repositories';
import {
  isBlockchainCoreBackendEnabled,
} from '../configuration/blockchain-core-config';
import { InMemoryBlockRepository } from '../repositories/in-memory-block-repository';
import { ProtocolBlockRepositoryAdapter } from '../repositories/protocol-block-repository-adapter';
import { BlockRuntimeService } from '../services/block-runtime-service';

let blockRuntimeService: BlockRuntimeService | null = null;

function isArmedWithIngestedGenesis(): boolean {
  return (
    process.env.RTWO_VALIDATOR_LIVE_ACTIVATION_ARMED?.trim().toLowerCase() === 'true' &&
    getProtocolRepositoriesSingleton().blocks.count() > 0
  );
}

export function isBlockchainCoreProtocolBackendActive(): boolean {
  return isBlockchainCoreBackendEnabled() || isArmedWithIngestedGenesis();
}

function resolveBlockRepository() {
  if (isBlockchainCoreProtocolBackendActive()) {
    return new ProtocolBlockRepositoryAdapter(getProtocolRepositoriesSingleton().blocks);
  }
  return new InMemoryBlockRepository();
}

export function getBlockRuntimeService(): BlockRuntimeService {
  if (!blockRuntimeService) {
    blockRuntimeService = new BlockRuntimeService(resolveBlockRepository());
  }
  return blockRuntimeService;
}

export function resetBlockRuntimeServiceForTests(): void {
  blockRuntimeService = null;
}

/** Rebind after canonical genesis ingestion when backend becomes active mid-process. */
export function refreshBlockRuntimeServiceFromProtocolEngine(): void {
  if (!isBlockchainCoreProtocolBackendActive()) {
    return;
  }
  blockRuntimeService = new BlockRuntimeService(resolveBlockRepository());
}

export function isBlockchainCoreRuntimeBackendConnected(): boolean {
  if (!isBlockchainCoreProtocolBackendActive()) {
    return false;
  }
  return getBlockRuntimeService().getLatestBlock().backendConnected;
}
